module.exports = __webpack_public_path__ + "img/4.5358d090.png";